import "./Amenidades.css";

import {
  FaShieldAlt,
  FaCar,
  FaBuilding,
  FaLeaf,
  FaDumbbell,
  FaChild,
  FaMapMarkerAlt,
  FaCalendarAlt,
} from "react-icons/fa";

const amenidades = [
  {
    icono: <FaShieldAlt />,
    titulo: "Seguridad 24/7",
    texto: "Acceso controlado y vigilancia permanente para tu tranquilidad.",
  },
  {
    icono: <FaCar />,
    titulo: "Parqueos techados",
    texto: "Amplios espacios para residentes y visitantes.",
  },
  {
    icono: <FaBuilding />,
    titulo: "Ascensor moderno",
    texto: "Acceso cómodo y seguro a todos los niveles.",
  },
  {
    icono: <FaLeaf />,
    titulo: "Áreas verdes",
    texto: "Espacios naturales para relajarte y disfrutar en familia.",
  },
  {
    icono: <FaDumbbell />,
    titulo: "Gimnasio equipado",
    texto: "Mantén tu estilo de vida saludable sin salir de casa.",
  },
  {
    icono: <FaChild />,
    titulo: "Área infantil",
    texto: "Un lugar seguro y divertido para los más pequeños.",
  },
];

function Amenidades() {
  return (
    <section className="amenidades" id="amenidades">

      <div className="amenities-heading">
        <span>AMENIDADES</span>

        <h2>
          Todo lo que necesitas en <strong>un solo lugar</strong>
        </h2>
      </div>

      <div className="amenities-list">

        {amenidades.map((amenidad, index) => (
          <article className="amenity-item" key={index}>

            <div className="amenity-item-icon">
              {amenidad.icono}
            </div>

            <div>
              <h3>{amenidad.titulo}</h3>
              <p>{amenidad.texto}</p>
            </div>

          </article>
        ))}

      </div>

      <div className="amenities-location-bar">

        <div>
          <FaMapMarkerAlt />

          <strong>
            Ubicado en Madre Vieja Sur, San Cristóbal
          </strong>
        </div>

        <span>
          Un entorno tranquilo, seguro y de alta valorización.
        </span>

        <a href="#reserva">
          <FaCalendarAlt />
          Agenda una visita
        </a>

      </div>

    </section>
  );
}

export default Amenidades;